import { useEffect } from 'react';
import { api } from '../utils/api';
import { useEditorStore } from '../store/editorStore';
import { useWorkspace } from '../contexts/WorkspaceContext';
import { mapRackTelemetry } from '../utils/telemetryProvenance.logic';

export function useTelemetry(code: string | undefined) {
  const { activeLens, setTelemetryData, racks, whatIfActive } = useEditorStore();
  const { activeWorkspaceId } = useWorkspace();

  useEffect(() => {
    if (activeLens === 'none' || !code || whatIfActive) return;
    const endpoint = activeLens === 'spof' ? 'spof' : 'telemetry';
    const controller = new AbortController();
    const refresh = async () => {
      try {
        const { data } = await api.get(`/api/datacenters/${code}/${endpoint}`, {
          params: { workspace: activeWorkspaceId }, signal: controller.signal,
        });
        if (!controller.signal.aborted) setTelemetryData(mapRackTelemetry(racks, data));
      } catch {
        if (!controller.signal.aborted) setTelemetryData({});
      }
    };
    setTelemetryData({});
    void refresh();
    const timer = setInterval(() => { void refresh(); }, 15_000);
    return () => { controller.abort(); clearInterval(timer); };
  }, [activeLens, code, racks, setTelemetryData, activeWorkspaceId, whatIfActive]);
}
